import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './ui/app.scss';
import { LogProvider } from './context/LogContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LogProvider>
      <App />
    </LogProvider>
  </React.StrictMode>,
);
